import React from 'react'
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import moment from 'moment'
import {floatToString} from 'utils/Number';

import theme from './ComplaintList.scss'
import complaintExtended from './complaintExtended.png'

import {getMessage as msg} from 'MessageBundle'
import BaseComponent from 'common/BaseComponent'
import Table, {SORT_ORDER} from 'common/Table'

const cx = classnames.bind(theme);

/**
 * Customized table row to apply CSS styles by condition.
 */
class ComplaintRow extends React.Component {

    render() {
        return (
            <tr className={cx({
                rowNew: this.props.value.state === "OPEN",
                rowDisabled: this.props.value.lockedBy,
                selectable: this.props.selectable
            })} onClick={this.props.onClick}>
                {this.props.children}
            </tr>
        );
    }
}

/**
 * Shows table with the complaints.
 */
export default class ComplaintList extends BaseComponent {

    constructor(props) {
        super(props);

        this.tableStructureInit();
    }

    componentDidUpdate(prevProps) {
        if(this.props.selectedBasket.salesPartnerColumnRendered !== prevProps.selectedBasket.salesPartnerColumnRendered) {
            this.tableStructureInit();
        }
    }

    processBodyClass = (lockedBy, commonStyle) => {
        const editable = !lockedBy || this.props.currentUserName === lockedBy;
        return editable ? commonStyle : commonStyle + ' ' + theme.columnDisable;
    };

    tableStructureInit = () => {
        this.tableStructure = [
            {
                attribute: "complaintNumber", label: msg('complaintList.complaintNumber'), fullLabel: msg('complaintList.complaintNumber.full'),
                width: '100px', headStyle: theme.complaintNumber, bodyStyle: (row) => this.processBodyClass(row.lockedBy, theme.txtRight),
                render: (row) => {return row.complaintNumber}
            },
            {
                attribute: "arrived", label: msg('complaintList.arrivedHdr'), title: msg('complaintList.arrivedTitle'), width: '130px',
                headStyle: theme.arrivedHdr, bodyStyle: (row) => this.processBodyClass(row.lockedBy, theme.txtRight),
                render: (row) => {return moment(row.arrived).format('DD.MM.YYYY, HH:mm')}
            },
            {
                attribute: "hvo", label: msg('complaintList.hvoHdr'), width: '80px',
                headStyle: theme.hvoHdr, bodyStyle: (row) => this.processBodyClass(row.lockedBy, theme.txtRight),
                render: (row) => {return row.mainVo}
            },
            {
                attribute: "uvo", label: msg('complaintList.uvoHdr'), width: '80px',
                headStyle: theme.uvoHdr, bodyStyle: (row) => this.processBodyClass(row.lockedBy, theme.txtRight),
                render: (row) => {return row.subVo}
            },
            {
                attribute: "type", label: msg('complaintList.typeHdr'), width: this.props.selectedBasket.salesPartnerColumnRendered ? '158px' : '210px',
                headStyle: theme.typeHdr, bodyStyle: (row) => this.processBodyClass(row.lockedBy, ''),
                render: (row) => {return <div className={theme.txtOverflow} title={row.type}>{row.type}</div>}
            },
            {
                attribute: "amount", label: msg('complaintList.amountHdr'), title: msg('complaintList.amountHdr.title'), width: '181px',
                headStyle: theme.amountHdr, bodyStyle: (row) => this.processBodyClass(row.lockedBy, theme.txtRight,  theme.amountHdr),
                render: (row) => {return row.amount ? floatToString(row.amount) : ""}
            },
            {
                attribute: "lockedBy", label: msg('complaintList.lockedByHdr'), width: '108px',
                headStyle: theme.lockedByHdr, bodyStyle: (row) => this.processBodyClass(row.lockedBy, ''),
                render: (row) => {return <div className={theme.txtOverflow} title={row.lockedBy}>{row.lockedBy}</div>}
            }
        ];

        if (this.props.selectedBasket.salesPartnerColumnRendered) {
            this.tableStructure.push(
                {
                    attribute: "notProcessed", label: msg('complaintList.notProcessedHdr'), fullLabel: msg('complaintList.notProcessedHdr.full'),
                    width: '80px', headStyle: theme.act, bodyStyle: (row) => this.processBodyClass(row.lockedBy, theme.txtCenter),
                    render: (row) => {
                        if (row.notProcessed) {
                            return (
                                <div className={theme.btnEdit}>
                                    <img src={complaintExtended} title={msg('complaintList.akt')} alt={msg('complaintList.akt')}/>
                                </div>
                            );
                        } else {
                            return null;
                        }
                    }
                }
            )
        }
    };

    openFailedArchiving = (complaint, parameters) => () => {
        let params = "";
        if (parameters) {
            parameters.forEach(p => params += ";" + p);
        }
        window.open('/retryArchiving/' + btoa(complaint.complaintNumber), '_blank',
            'left=200,top=200,width=570,height=550,menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes');
    };

    render() {
        const handleSelect = this.props.selectedBasket.archivingFailed ? this.openFailedArchiving : this.openComplaint;
        return (
            <div className={theme.content}>
                <h2>{this.props.selectedBasket.name}</h2>
                <div className={theme.tblWrap}>
                    <div className={theme.tblWrapInner}>
                        <Table structure={this.tableStructure} value={this.props.value} customRow={ComplaintRow} sortable
                            defaultSortColumn="arrived" defaultSortOrder={SORT_ORDER.DESC} selectable onSelect={handleSelect}
                            className={theme.complaintListTbl}/>
                    </div>
                </div>
            </div>
        );
    }
}

ComplaintList.propTypes = {
    /**
     * List of the complaints.
     */
    value: PropTypes.array.isRequired,

    /**
     * The selected basket.
     */
    selectedBasket: PropTypes.object.isRequired,

    /**
     * The name of the current user.
     */
    currentUserName: PropTypes.string.isRequired
};


// WEBPACK FOOTER //
// ./src/dialogs/VPRekla/Start/ComplaintList/index.js